import {
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Table } from "react-bootstrap";
import * as React from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CurrencyFormat from "react-currency-format";
import { NumericFormat } from "react-number-format";
import { GetSubMData } from "../../store/subscriptionAtom";
import Select from "react-select";
import DeleteIcon from "@mui/icons-material/Delete";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";
import { MdDelete } from "react-icons/md";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function AddSubscriptionTable(props) {
  const { productPlanList, discountAmount } = props;
  const getSubMData = GetSubMData();



  const getSubTotal = (list) => {
    let temp = 0;
    list.forEach((product) => {
      temp += product.Rate * product.Quantity;
    });
    return temp;
  };

  return (
    <>
     
      <div>
        <TableContainer className="min-h-[320px] w-full bg-white overflow-x-auto">
          <Table
            sx={{ minWidth: 750 }}
            className="w-full text-sm"
            aria-label="product table"
          >
            <colgroup>
              <col style={{ width: "25%" }} />
              <col style={{ width: "20%" }} />
              <col style={{ width: "20%" }} />
              {/* <col style={{ width: "25%" }} /> */}
              <col style={{ width: "25%" }} />
            </colgroup>

            <TableHead className="bg-gray-100">
              <TableRow>
                {[
                  "Name",
                  "Qty",
                  "Unit Price",
                  "Amount",
                  "",
                ].map((label, idx) => (
                  <TableCell
                    key={idx}
                    className="text-xs font-semibold text-gray-700 uppercase tracking-wide py-2 px-2 whitespace-nowrap"
                  >
                    {label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {productPlanList?.map((product, i) => (
                <TableRow key={i} className="hover:bg-gray-50 border-b">
                  <TableCell
                    title={product?.Item_Name}
                    className="text-xs font-medium text-gray-800 truncate max-w-[200px] px-2 cursor-default"
                  >
                    {product?.Item_Name}
                  </TableCell>

                  <TableCell className="px-2">
                    <NumericFormat
                      value={product?.Quantity}
                      style={{
                        width: "80px",
                        fontSize: "0.75rem",
                        padding: "4px 6px",
                        border: "1px solid #d1d5db",
                        borderRadius: "0.375rem",
                      }}
                      // thousandSeparator=","
                      // decimalSeparator="."
                      allowedDecimalSeparators={["%"]}
                      onValueChange={(values) =>
                        props?.onAddonQuantityChange(
                          parseFloat(Number(values.value)),
                          i
                        )
                      }
                    />
                  </TableCell>

                  <TableCell className="text-xs text-gray-700 px-2">
                    <NumericFormat
                      value={product?.Rate}
                      style={{
                        width: "80px",
                        fontSize: "0.75rem",
                        padding: "4px 6px",
                        border: "1px solid #d1d5db",
                        borderRadius: "0.375rem",
                      }}
                      // thousandSeparator=","
                      // decimalSeparator="."
                      onValueChange={(values) =>
                        props?.onRateChange(
                          parseFloat(Number(values.value)),
                          i
                        )
                      }
                    />
                  </TableCell>

        

                  <TableCell className="text-xs font-semibold text-gray-800 px-2">
                    <CurrencyFormat
                      value={formatCustomNumber(
                        product.Rate * product.Quantity
                      )}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={"₦"}
                    />
                  </TableCell>

                  <TableCell className="px-2">
                    <button type="button" className="p-1 rounded-full hover:bg-red-100">
                      <MdDelete
                        className="h-4 w-4 text-red-500 hover:text-red-600 transition"
                        onClick={() => props?.removeOldAddon(i)}
                      />
                    </button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {/* Totals */}
        <div className="flex justify-end px-4 py-3 border-t bg-gray-50 text-sm text-gray-700">
          <ol className="text-right space-y-1">
            <li className="font-semibold">
              SubTotal: ₦{formatCustomNumber(getSubTotal(productPlanList))}
            </li>
            <li className="font-semibold">
              Discount: ₦{formatCustomNumber(discountAmount)}
            </li>
            <li className="font-semibold">
              Net: ₦
              {formatCustomNumber(
                getSubTotal(productPlanList) - discountAmount
              )}
            </li>
          </ol>
        </div>
      </div>
    </>
  );
}

export default AddSubscriptionTable;
